import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { firebaseApp } from "./firebase";
import { saveToStorage } from "../utils/Helper";
import { StorageConstants } from "../constants/Constants";

export const initializeWebPush = async () => {
    try {
        const messaging = getMessaging(firebaseApp);

        const permission = await Notification.requestPermission();
        if (permission !== "granted") {
            console.warn("Push permission not granted for web");
            return;
        }

        const token = await getToken(messaging, {
            vapidKey: "BEKyV_4AU3xcFs1-wHj11hGXi4aeHbyh8lBalMwcZx8TpyEuDheOs2htG3WFUa4lFVvAK861JZTH7keBxnS1pKA", // From Firebase → Cloud Messaging → Web Push Certificates
        });

        console.log("✅ Web FCM Token:", token);
        saveToStorage({ key: StorageConstants?.FCM_TOKEN, value: token })
        // Send token to your backend here if needed

        // Listen for foreground messages
        onMessage(messaging, (payload) => {
            console.log("📩 Message received in foreground:", payload);
            new Notification(payload.notification?.title ?? "Notification", {
                body: payload.notification?.body,
            });
        });
    } catch (err) {
        console.error("Error initializing web push:", err);
    }
};
